import { render } from "./BestPractisesView.vue?vue&type=template&id=682b1af9"
import script from "./BestPractisesView.vue?vue&type=script&lang=js"
export * from "./BestPractisesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__